export const wilayas =
    [
        {
            "id": 1,
            "code": "01",
            "name_ar": "أدرار",
            "name": "Adrar",
        },
        {
            "id": 2,
            "code": "02",
            "name_ar": " الشلف",
            "name": "Chlef",
        },
        {
            "id": 3,
            "code": "03",
            "name_ar": "الأغواط",
            "name": "Laghouat",
        },
        {
            "id": 4,
            "code": "04",
            "name_ar": "أم البواقي",
            "name": "Oum El Bouaghi",
        },
        {
            "id": 5,
            "code": "05",
            "name_ar": "باتنة",
            "name": "Batna",
        },
        {
            "id": 6,
            "code": "06",
            "name_ar": " بجاية",
            "name": "Béjaïa",
        },
        {
            "id": 7,
            "code": "07",
            "name_ar": "بسكرة",
            "name": "Biskra",
        },
        {
            "id": 8,
            "code": "08",
            "name_ar": "بشار",
            "name": "Béchar",
        },
        {
            "id": 10,
            "code": "08",
            "name": "Bouira",
        },
        {
            "id": 9,
            "code": "09",
            "name_ar": "البليدة",
            "name": "Blida",
        },
        {
            "id": 11,
            "code": "11",
            "name_ar": "تمنراست",
            "name": "Tamanrasset",
        },
        {
            "id": 12,
            "code": "12",
            "name_ar": "تبسة",
            "name": "Tébessa",
        },
        {
            "id": 13,
            "code": "13",
            "name_ar": "تلمسان",
            "name": "Tlemcen",
        },
        {
            "id": 14,
            "code": "14",
            "name_ar": "تيارت",
            "name": "Tiaret",
        },
        {
            "id": 15,
            "code": "15",
            "name_ar": "تيزي وزو",
            "name": "Tizi Ouzou",
        },
        {
            "id": 16,
            "code": "16",
            "name_ar": "الجزائر",
            "name": "Alger",
        },
        {
            "id": 17,
            "code": "17",
            "name_ar": "الجلفة",
            "name": "Djelfa",
        },
        {
            "id": 18,
            "code": "18",
            "name_ar": "جيجل",
            "name": "Jijel",
        },
        {
            "id": 19,
            "code": "19",
            "name_ar": "سطيف",
            "name": "Sétif",
        },
        {
            "id": 20,
            "code": "20",
            "name_ar": "سعيدة",
            "name": "Saïda",
        },
        {
            "id": 21,
            "code": "21",
            "name_ar": "سكيكدة",
            "name": "Skikda",
        },
        {
            "id": 22,
            "code": "22",
            "name_ar": "سيدي بلعباس",
            "name": "Sidi Bel Abbès",
        },
        {
            "id": 23,
            "code": "23",
            "name_ar": "عنابة",
            "name": "Annaba",
        },
        {
            "id": 24,
            "code": "24",
            "name_ar": "قالمة",
            "name": "Guelma",
        },
        {
            "id": 25,
            "code": "25",
            "name_ar": "قسنطينة",
            "name": "Constantine",
        },
        {
            "id": 26,
            "code": "26",
            "name_ar": "المدية",
            "name": "Médéa",

        },
        {
            "id": 27,
            "code": "27",
            "name_ar": "مستغانم",
            "name": "Mostaganem",
        },
        {
            "id": 28,
            "code": "28",
            "name_ar": "المسيلة",
            "name": "M'Sila",
        },
        {
            "id": 29,
            "code": "29",
            "name_ar": "معسكر",
            "name": "Mascara",
        },
        {
            "id": 30,
            "code": "30",
            "name_ar": "ورقلة",
            "name": "Ouargla",

        },
        {
            "id": 31,
            "code": "31",
            "name_ar": "وهران",
            "name": "Oran",

        },
        {
            "id": 32,
            "code": "32",
            "name_ar": "البيض",
            "name": "El Bayadh",

        },
        {
            "id": 33,
            "code": "33",
            "name_ar": "إليزي",
            "name": "Illizi",

        },
        {
            "id": 34,
            "code": "34",
            "name_ar": "برج بوعريريج",
            "name": "Bordj Bou Arreridj",

        },
        {
            "id": 35,
            "code": "35",
            "name_ar": "بومرداس",
            "name": "Boumerdès",

        },
        {
            "id": 36,
            "code": "36",
            "name_ar": "الطارف",
            "name": "El Tarf",

        },
        {
            "id": 37,
            "code": "37",
            "name_ar": "تندوف",
            "name": "Tindouf",

        },
        {
            "id": 38,
            "code": "38",
            "name_ar": "تيسمسيلت",
            "name": "Tissemsilt",

        },
        {
            "id": 39,
            "code": "39",
            "name_ar": "الوادي",
            "name": "El Oued",

        },
        {
            "id": 40,
            "code": "40",
            "name_ar": "خنشلة",
            "name": "Khenchela",
        },
        {
            "id": 41,
            "code": "41",
            "name_ar": "سوق أهراس",
            "name": "Souk Ahras",

        },
        {
            "id": 42,
            "code": "42",
            "name_ar": "تيبازة",
            "name": "Tipaza",

        },
        {
            "id": 43,
            "code": "43",
            "name_ar": "ميلة",
            "name": "Mila",

        },
        {
            "id": 44,
            "code": "44",
            "name_ar": "عين الدفلة",
            "name": "Aïn Defla",

        },
        {
            "id": 45,
            "code": "45",
            "name_ar": "النعامة",
            "name": "Naâma",

        },
        {
            "id": 46,
            "code": "46",
            "name_ar": "عين تيموشنت",
            "name": "Aïn Témouchent",

        },
        {
            "id": 47,
            "code": "47",
            "name_ar": "غرداية",
            "name": "Ghardaia",

        },
        {
            "id": 48,
            "code": "48",
            "name_ar": "غليزان",
            "name": "Relizane",
        }
    ];
